import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4657c615"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "Tutorial"
}
const _hoisted_2 = { class: "Tutorial__Inner" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Tutorial__Overlay" }, null, -1))
const _hoisted_4 = { class: "Tutorial__Main" }
const _hoisted_5 = { class: "Tutorial__Footer" }
const _hoisted_6 = { class: "Tutorial__Progress" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonHover = _resolveComponent("ButtonHover")!
  const _component_FocusTrap = _resolveComponent("FocusTrap")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "tutorial" }, {
      default: _withCtx(() => [
        (_ctx.active)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_FocusTrap, { active: _ctx.active }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _hoisted_3,
                    _createElementVNode("div", _hoisted_4, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nbSteps, (index) => {
                        return (_openBlock(), _createBlock(_Transition, {
                          key: 'step-'+index,
                          name: "step"
                        }, {
                          default: _withCtx(() => [
                            (_ctx.step === index)
                              ? _renderSlot(_ctx.$slots, 'step'+index, {
                                  key: 0,
                                  step: _ctx.step
                                }, undefined, true)
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _createElementVNode("footer", _hoisted_5, [
                      _createVNode(_component_ButtonHover, {
                        "data-fixed": "",
                        type: "button",
                        class: "button button--white button--small",
                        onClick: _ctx.nextStep
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('chapter.tutorialButton')), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createElementVNode("ul", _hoisted_6, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nbSteps, (index) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: 'button-'+index,
                            class: _normalizeClass({ 'active': _ctx.step >= index })
                          }, null, 2))
                        }), 128))
                      ])
                    ])
                  ])
                ]),
                _: 3
              }, 8, ["active"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ]))
}